import { Menu } from 'antd';
import styled from 'styled-components';

interface Props {
  selected?: boolean;
}

export const RangePickerMenuItem = styled(Menu.Item).attrs<Props>(
  ({ selected }) => ({
    className: selected ? 'ant-dropdown-menu-item-selected' : '',
  }),
)<Props>``;
